// @ts-check
// Upgrade visible carousels without loading the interaction module upfront.
const script = document.querySelector('script[data-tucky-carousel-module]');
const moduleUrl = script?.getAttribute('data-tucky-carousel-module');
/** @type {Promise<unknown> | undefined} */
let loading;
const loadModule = () => {
  if (!moduleUrl) return Promise.resolve();
  loading ??= import(moduleUrl).then(() => observer.disconnect());
  return loading;
};
const observer = new IntersectionObserver((entries) => {
  if (!entries.some((entry) => entry.isIntersecting) || !moduleUrl) return;
  void loadModule();
}, { rootMargin: '200px' });

/** @param {ParentNode} root */
const observeCarousels = (root) => {
  if (customElements.get('tucky-carousel')) return;
  root.querySelectorAll('tucky-carousel').forEach((carousel) => observer.observe(carousel));
};

observeCarousels(document);
document.addEventListener('shopify:block:select', (event) => {
  if (!moduleUrl || customElements.get('tucky-carousel') || !(event.target instanceof Element)) return;
  const target = event.target;
  if (!target.closest('tucky-carousel')) return;
  void loadModule().then(() => {
    if (target.isConnected)
      target.dispatchEvent(new CustomEvent(event.type, { bubbles: true, detail: event instanceof CustomEvent ? event.detail : undefined }));
  });
});
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) observeCarousels(event.target);
});
document.addEventListener('shopify:section:unload', (event) => {
  if (event.target instanceof Element)
    event.target.querySelectorAll('tucky-carousel').forEach((carousel) => observer.unobserve(carousel));
});
